import { useEffect, useRef } from "react";
import { useOffice } from "@/office/office-context";

export function StepTimeline() {
  const office = useOffice();
  const scroller = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = scroller.current;
    if (!node) return;
    if (office.activeStepId === null) {
      node.scrollLeft = node.scrollWidth;
      return;
    }
    const chip = node.querySelector<HTMLElement>(`[data-step-id="${office.activeStepId}"]`);
    chip?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [office.steps.length, office.activeStepId]);

  return (
    <div className="shrink-0 border-t border-[#e3ded2] bg-[#fbfaf7]">
      <div className="flex items-center justify-between px-4 pb-1 pt-2 text-[11px] text-[#8d8679]">
        <span>操作时间轴 · 共 {office.steps.length} 步</span>
        <span className="hidden sm:block">点击任一步：左侧回到当时界面，右侧显示那一步的源码</span>
      </div>
      <div ref={scroller} className="flex gap-2 overflow-x-auto px-4 py-2">
        {office.steps.map((step) => {
          const active = office.activeStepId === step.id;
          return (
            <button
              key={step.id}
              type="button"
              data-step-id={step.id}
              onClick={() => office.selectStep(step.id)}
              className={`flex h-11 w-[132px] shrink-0 flex-col justify-center rounded border px-2 text-left transition-colors ${
                active
                  ? "border-[#e2b768] bg-[#fdf3df] text-[#7a5410]"
                  : "border-[#e2ded4] bg-white text-[#5d6672] hover:border-[#c9c2b3]"
              }`}
            >
              <span className="flex items-center gap-1.5 text-[11px] font-medium">
                <span
                  className={`h-1.5 w-1.5 shrink-0 rounded-full ${step.module === "doc" ? "bg-[#4f8cff]" : "bg-[#2fae7d]"}`}
                />
                <span className="truncate">{step.title}</span>
                <span className={`ml-auto font-mono text-[10px] ${active ? "text-[#a98544]" : "text-[#b3ab9d]"}`}>
                  {step.time}
                </span>
              </span>
              <span className={`mt-0.5 truncate font-mono text-[10px] ${active ? "text-[#9a7638]" : "text-[#a8a094]"}`}>
                #{String(step.index).padStart(2, "0")} {step.detail}
              </span>
            </button>
          );
        })}

        <button
          type="button"
          onClick={() => office.selectStep(null)}
          className={`flex h-11 w-[96px] shrink-0 flex-col justify-center rounded border px-2 text-left transition-colors ${
            office.activeStepId === null
              ? "border-[#1f2328] bg-[#1f2328] text-[#f7f5f0]"
              : "border-[#e2ded4] bg-white text-[#5d6672] hover:border-[#c9c2b3]"
          }`}
        >
          <span className="text-[11px] font-medium">最新状态</span>
          <span className={`text-[10px] ${office.activeStepId === null ? "text-[#b9c6d4]" : "text-[#a8a094]"}`}>
            可继续编辑
          </span>
        </button>
      </div>
    </div>
  );
}
